<link rel="stylesheet" href="https://unpkg.com/leaflet@1.8.0/dist/leaflet.css"
   integrity="sha512-hoalWLoI8r4UszCkZ5kL8vayOGVae1oxXe/2A4AO6J9+580uKHDO3JdHb7NzwwzK5xr/Fs0W40kiNHxM9vyTtQ=="
   crossorigin=""/>

<style>
    #map {
        display: block;
        flex: 1;
    }
</style>

<script>
    import L from 'leaflet';
    import { onMount } from 'svelte';
    import { getHTMLText } from './stringToUrl.js';

    export let items = []
    export let csv = ''
    export let selectedItemIndex = -1;
    export let scrollToBottomOfTextArea;
    export let edit = true
    let map = null
    let markers = {}
    let preventNextBoundsUpdate = false

    $ : updateItems(items)
    $ : refreshMap(edit)
    $ : hilightItem(selectedItemIndex)

    onMount(() => {
        map = L.map('map', { zoomControl: false }).setView([51.505, -0.09], 3);
        L.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png', {
            maxZoom: 19,
            attribution: '© OpenStreetMap'
        }).addTo(map);

        map.on('click', handleMapClick)
    })

    let handleMapClick = (e) => {
        if (!edit) {
            return;
        }

        let loc = {
            item_latitude : e.latlng.lat,
            item_longitude : e.latlng.lng,
        }

        csv = csv + `\nNew Item, ${e.latlng.lat}, ${e.latlng.lng}, Description`
        items.push(['New Item', loc.item_latitude, loc.item_longitude, 'Description'])
        preventNextBoundsUpdate = true
        scrollToBottomOfTextArea()
    }

    let refreshMap = (edit) => {
        if (!map) {
            return
        }
        map.invalidateSize();
        updateItems(items)
        hilightItem(selectedItemIndex)
    }

    let updateItems = (newItems) => {
        if (!map) {
            return
        }

        console.log("updateItems")

        for (let marker of Object.values(markers)) {
            map.removeLayer(marker)
        }

        if (newItems.length === 0 || newItems[0].length < 3) {
            return;
        }
        
        var mapBounds
        try {
            mapBounds = L.latLngBounds([
                [newItems[0].lat, newItems[0].lng],
                [newItems[0].lat, newItems[0].lng]
            ]);
        } catch {
            return;
        }

        for (let item of newItems) {
            if (item.length < 3) {
                continue
            }
            let icon = createIcon()
            let marker = L.marker([item.lat, item.lng], { icon: icon }).addTo(map);
            const popup = edit ?
                `<b>${item.name}</b>` :
                `<b>${item.name}</b><br><br>
                ${getHTMLText(item.description)}`;
            marker.bindPopup(popup)
            marker.on('click', e => {
                selectedItemIndex = item.index
            });
            markers[item.index] = marker;
            
            mapBounds.extend([item.lat, item.lng])
        }

        if (preventNextBoundsUpdate) {
            preventNextBoundsUpdate = false
            return
        }
        map.fitBounds(mapBounds.pad(0.2))
        hilightItem(selectedItemIndex)
    }

    let createIcon = () => {
        let options = {
            shadowUrl: '/markers/marker-shadow.png',
            iconSize: [48,48],
            iconAnchor: [24,48],
            tooltipAnchor: [0.5, -32],
            shadowSize: [41,41],
            shadowAnchor: [12,41],
            popupAnchor: [0.5, -32],
            iconUrl: '/markers/marker-icon.png',
		    iconRetinaUrl: '/markers/marker-icon-retina.png'
        }

        return L.icon(options);
    }

    let hilightItem = (index) => {
        if (!markers[index]) {
            return;
        }
        markers[index].openPopup()
    }
</script>

<div id="map"></div>
